<!--    
@author zhijie.huang
@date 2018/9/29
@version v1.1.0
@description instanceManage 实例管理
-->
<template>
  <div class="instanceManage__content">
    <el-form ref="form" :model="form" :inline="true" input-width="auto">
      <el-form-item :label="$t('agentManage.siteCode')">
        <g-select v-model="form.siteCode" :list="select_site"></g-select>
      </el-form-item>
      <el-form-item>
        <g-select :list="group" v-model="form.group" :default-all="true">
          <el-option
            v-for="(sitem, skey) in group"
            :key="skey"
            :label="sitem"
            :value="skey">
          </el-option>
        </g-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.appName" prefix-icon="uk-icon-search" :placeholder="$t('instanceManage.appName')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="e_search">{{ $t('common.search') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :cell-style="cellStyle"
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      :cellClick="e_cellClick"
      border>
    </el-table-extend>
  </div>
</template>
<script>
import rac from '@/plugins/rac-mixin'
import dic from '@/components/mixins/dic'
import table from '@/components/mixins/table'
import SiteListBiz from '@/logic/cmdb/cmdbBiz'
import instanceManageBiz from '@/logic/continuousDelivery/instanceManageBiz'
import { extend } from '@/utils/tool'
import TimeFormat from '@/utils/timeFormat'

export default {
  mixins: [rac, dic, table],
  data () {
    return {
      select_site: {},
      form: {
        siteCode: '',
        group: '',
        appName: ''
      },
      group: {}
    }
  },
  methods: {
    initTable () {
      this.tInitTable({
        lanKey: 'instanceManage.table',
        head: ['siteCode', 'group', 'appName', 'version', 'developer', 'tester', 'operations', 'createTime', 'count'],
        headOpt: {
          siteCode: {
            formatter: 'Dictionary',
            formatterDic: this.select_site
          }
        },
        requestFun: this.search
      })
    },
    getSiteList () {
      SiteListBiz.siteList({ perPageCount: 500 }).then((data) => {
        let list = {}
        data.dataList.map((item) => {
          list[item.siteCode] = item.name
        })
        this.select_site = list
        this.form.siteCode = Object.keys(this.select_site)[0]
        this.initTable()
        this.search()
      })
    },
    search (data) {
      const reqData = extend(true, data, this.form)
      instanceManageBiz.manageList(reqData).then((data) => {
        if (data && data.dataList) {
          data.dataList.map((item) => {
            item.createTime = TimeFormat.getFormatTime(item.createTime)
          })
        }
        this.tData = data
      })
    },
    async preSetGroupData (siteCode, siteChange) {
      if (this.form.group && Object.keys(this.form.group).length > 0) return
      await this.dGetGroup(siteCode, siteChange)
      const group = {}
      for (const key in this.dDictionaryGroup) {
        group[key] = this.dDictionaryGroup[key]
      }
      this.group = this.dDictionaryGroup
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7) {
        return 'color:#0B8DE5; cursor:pointer'
      }
    },
    e_search () {
      // this.preSetGroupData()
      this.search(extend({}, this.form))
    },
    e_cellClick (row, columnKey) {
      if (columnKey === 'count') {
        const packageName = row.packageName
        const appName = row.appName
        const group = row.group
        const version = row.version
        this.$router.push({
          name: 'instanceList',
          query: {
            packageName: packageName,
            appName: appName,
            group: group,
            version: version
          }
        })
      }
    }
  },
  watch: {
    'form.siteCode': function (val) {
      this.preSetGroupData(val, true)
      this.form.group = ''
      this.form.appName = ''
    }
  },
  mounted () {
    this.getSiteList()
  }
}
</script>